import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DigitalProspectClient } from './digital-prospect-client';

@Injectable({
  providedIn: 'root',
})
export class DigitalProspectService {
  private readonly digitalProspectClient: DigitalProspectClient;

  constructor() {
    this.digitalProspectClient = new DigitalProspectClient(
      environment.mainDomain,
      environment.env,
      environment.localDomainOverride ?? undefined,
      undefined
    );
  }

  public init(): void {
    this.digitalProspectClient.init();
  }

  /** Async init used by AppComponent so DPID cookies are ready before other analytics. */
  public initAsync(): Promise<void> {
    return this.digitalProspectClient.init();
  }

  public extendSession(expires?: number | Date): void {
    this.digitalProspectClient.extendSession(expires);
  }
}
